import type { Locale } from '@/types';

const intlLocales: Record<Locale, string> = {
  kz: 'kk-KZ',
  ru: 'ru-RU',
  en: 'en-US',
};

export const toIntlLocale = (locale: Locale): string => intlLocales[locale];

export const formatDateLong = (date: Date, locale: Locale): string =>
  new Intl.DateTimeFormat(toIntlLocale(locale), {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);

export const formatDateTime = (date: Date, locale: Locale): string => {
  const intl = toIntlLocale(locale);
  const day = formatDateLong(date, locale);
  const time = new Intl.DateTimeFormat(intl, { hour: '2-digit', minute: '2-digit' }).format(date);
  return `${day} · ${time}`;
};

export const formatNumber = (value: number, locale: Locale): string =>
  new Intl.NumberFormat(toIntlLocale(locale)).format(value);

export const formatDate = (iso: string, locale: Locale): string =>
  new Intl.DateTimeFormat(toIntlLocale(locale), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(iso));

export const initialsFrom = (fullName: string): string =>
  fullName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
